import React, { useState } from 'react';

import { createChatService } from '../../services/chatService';
import AIChatQuotaProvider from './AIChatQuotaProvider';

type TeacherToolsQuotaProviderProps = {
  children: React.ReactNode;
};

/**
 * The teacher's quota on the teacher tools screens that have no chat service of their own. Each
 * screen mounts it, so the quota is read on entering it.
 */
function TeacherToolsQuotaProvider({ children }: TeacherToolsQuotaProviderProps): JSX.Element {
  // Created once: a new instance on each render would re-read the quota every time.
  const [chatService] = useState(() => createChatService());

  return <AIChatQuotaProvider chatService={chatService}>{children}</AIChatQuotaProvider>;
}

export default TeacherToolsQuotaProvider;
